import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ClientSidePermissionStates } from '../../../permission/client-side-permissions-controller/states';

@Component({
  selector: 'app-feature-visibility-teams',
  templateUrl: './feature-visibility-teams.component.html',
  styleUrls: ['./feature-visibility-teams.component.css']
})
export class FeatureVisibilityTeamsComponent implements OnInit {

  constructor(private readonly store: Store<ClientSidePermissionStates>) { }

  ngOnInit() {
  }

}
